var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18085_120)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18085_120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24727 30.0741H46.6667M8.55576 28.6914H47.3582M44.0718 34.2222H47.3582M44.0718 32.8395H47.3582M44.0718 31.4568H47.3582M9.24727 23.1605H46.6667M10.3399 21.7778H45.5758M22.4015 19.0123H33.5141M22.4015 17.6296H33.5141M18.0502 14.8642H37.8655M18.0502 13.4815H37.8655M15.2651 10.716H40.6505M15.2651 9.33333H40.6505M44.0718 27.3086H47.3582M44.0718 25.9259H47.3582M44.0718 24.5432H47.3582M8.55576 34.2222H11.8422M8.55576 32.8395H11.8422M8.55576 31.4568H11.8422M8.55576 27.3086H11.8422M8.55576 25.9259H11.8422M8.55576 24.5432H11.8422M8.55576 35.6049H22.8856M8.55576 36.9877H22.8856M33.0301 35.6049H47.3582M33.0301 36.9877H47.3582M8.55576 38.3704H24.54M31.4604 38.3704H47.4446M8.55576 39.7531H47.4446M8.55576 41.1358H47.4446M8.55576 42.5185H47.4446M8.55576 43.9012H47.4446M8.96202 45.2839H47.0401M10.6476 46.6667H45.3528",
    stroke: "#4732D4",
    strokeWidth: 1.81481,
    strokeMiterlimit: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18085_120)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#4732D4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18085_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWallet);
export default __webpack_public_path__ + "static/media/connectWallet.6e059b269c50af70facba71d6294fe35.svg";
export { ForwardRef as ReactComponent };